let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("at21v")).then(() => parcelRequire('llpqT'));